
import { REQUEST_TYPE } from "./network/net";
import Stream from "./frp/stream";

export default function(
    leaf,
    {
        $pending,
        $request,
        $net
    },
    serverOptions,
    lobbyURL,
    $error
)
{
    $error.subscribe( e => console.error( "Network error:", e ) );
    
    //fatal:
    const $fatal = $error.filter( ({ type }) => type == "fatal" )
    $fatal.subscribe( () => leaf.showFatalErrorBanner() );
    //is error:
    const $isError = new Stream( "isError" );
    $error
        .filter( ({ type }) => type == "fail" )
        .map( () => true )
        .merge( $fatal.map( () => true ) )
        .merge( $net.map( () => false ) )
        .subscribe( $isError );
    //fail:
    $isError
        .distinctUntilChanged()
        .subscribe( show => show ? leaf.showNoConnectionBanner() : leaf.hideNoConnectionBanner() );
    //reconnections:
    let reconnectTimeout = undefined;
    $isError
        .filter( isError => isError )
        .subscribe( fail =>
        {
            if ( reconnectTimeout )
            {
                clearTimeout( reconnectTimeout );
                reconnectTimeout = undefined;
            }
            
            if ( fail )
            {
                reconnectTimeout = setTimeout(
                    () =>
                    {
                        reconnectTimeout = undefined;
                        
                        $request.next( {
                            type : REQUEST_TYPE.INIT,
                            options : serverOptions
                        } )
                    },
                    4100
                );
            }
        } );
    
    $fatal.subscribe( fatal => {
        if ( fatal.redirectUrl )
        {
            window.location.replace( redirectUrl );
            return;
        }
        setTimeout( () => goLobby( lobbyURL ), 5000 );
    } );
    
    //preloader:
    const $preloader = new Stream( "progress_indicator" );
    let timeout = undefined;
    //start countdown:
    $pending
        .filter( pending => pending )
        .subscribe( () =>
        {
            //as I understand, it may happen because of orderless events propagation - spin->request may turn out to be just "spin":
            //how?:
            if ( timeout )
            {
                //console.error( "HOW!?" );
                return;
            }
            
            timeout = setTimeout( () =>
            {
                timeout = undefined;
                $preloader.next( true );
            }, 3000 );
        } );
    //cancel countdown or hide it:
    $net
        .merge( $isError.filter( isError => isError ) )
        .subscribe( () =>
        {
            if ( timeout ) clearTimeout( timeout );
            timeout = undefined;
            $preloader.next( false );
        } );
    $preloader.subscribe( show => show ? leaf.showProcessIndicator() : leaf.hideProcessIndicator() );
    
    const $goLobby = new Stream( "goLobby" );
    $goLobby.on( () => goLobby( lobbyURL ) );
    
    return {
        $isError,
        $goLobby,
        $preloader
    };
}

//TODO: can determine if lobby is present with this way:
//run.ui.ui.havingLobby = server.lobbyURL && server.lobbyURL.length > 0 ? true : false;
function goLobby( lobbyURL )
{
    //for now game is hosted throughout multiple lobby pages and so we do not assume any default lobby anymore:
    if ( ! lobbyURL ) return;
    /*const inIframe = function () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    };
    
    //теперь игры хостятся в iframe и надо сообщить родительскому контейнеру что игра хочет перейти в лобби (по ошибке или по желанию игрока):
    if ( inIframe() )
    {
        window.top.postMessage( "game_close", "*" );
    }
    //пусть старый код работает если игра хостится по-старому (например в разработческом лобби):
    else
    {*/
        window.location.replace( lobbyURL );
    //}
};




// WEBPACK FOOTER //
// ./src/library/error.es6